"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getErrorMessageNoProjectIdFoundInApp = (callerName) => `${callerName}: No projectId found on app`;
exports.default = getErrorMessageNoProjectIdFoundInApp;
